<div class="custom-tree">
  <div *ngIf="data && data.length > 0; else emptyState"
       cdkDropList
       [id]="getDropListId()"
       [cdkDropListData]="data"
       (cdkDropListDropped)="onDrop($event, 0)"
       (cdkDragEntered)="onDragEnter($event)"
       (cdkDragExited)="onDragExit($event)"
       [class.invalid-drop]="isInvalidDrop(getDropListId())"
       class="tree-drop-list">
    <div *ngFor="let node of data; let i = index"
         class="tree-node"
         cdkDrag
         [cdkDragDisabled]="!enableDragSort"
         [cdkDragData]="node">

      <!-- 递归渲染节点 -->
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node, level: 0 }">
      </ng-container>
    </div>
  </div>

  <!-- 空状态 -->
  <ng-template #emptyState>
    <div class="empty-state">
      <p>暂无数据</p>
    </div>
  </ng-template>
</div>

<!-- 递归节点模板 -->
<ng-template #nodeTemplate let-node let-level="level">
  <div class="node-content" (click)="toggleNode(node, $event)" [style.padding-left]="getIndentLevel(level)">
    <div class="node-header">
      <!-- 拖拽手柄 -->
      <span *ngIf="enableDragSort" class="drag-handle" cdkDragHandle>
        <i nz-icon nzType="unordered-list" nzTheme="outline" class="drag-icon"></i>
      </span>

      <!-- 文件夹图标 -->
      <span class="folder-icon">
        <i nz-icon
           [nzType]="hasChildren(node) ? (isExpanded(node) ? 'folder-open' : 'folder') : 'file'"
           nzTheme="outline"
           class="folder">
        </i>
      </span>

      <!-- 节点名称 -->
      <span class="node-name">{{ node.name }}</span>
    </div>

    <!-- 操作按钮 -->
    <div *ngIf="showActions" class="node-actions" (click)="$event.stopPropagation()">
      <!-- <ng-container *ngIf="actionTemplate; else defaultActions">
        <ng-container *ngTemplateOutlet="actionTemplate; context: { $implicit: node }">
        </ng-container>
      </ng-container> -->
      <ng-container *ngIf="!actionTemplate">
        <ng-container *ngTemplateOutlet="defaultActions; context: { $implicit: node }">
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- 子节点 -->
  <div *ngIf="hasChildren(node) && isExpanded(node)"
       class="node-children"
       [@expandCollapse]>
    <div cdkDropList
         [id]="getDropListId(node.id)"
         [cdkDropListData]="node.children"
         (cdkDropListDropped)="onDrop($event, level + 1, node.id)"
         (cdkDragEntered)="onDragEnter($event)"
         (cdkDragExited)="onDragExit($event)"
         [class.invalid-drop]="isInvalidDrop(getDropListId(node.id))"
         class="tree-drop-list">
      <div *ngFor="let childNode of node.children; let j = index"
           class="tree-node"
           cdkDrag
           [cdkDragDisabled]="!enableDragSort"
           [cdkDragData]="childNode">

        <!-- 递归调用子节点模板 -->
        <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: childNode, level: level + 1 }">
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- 默认操作按钮模板 -->
<ng-template #defaultActions let-node>
  <button nz-button
          nzType="link"
          nzSize="small"
          class="action-btn edit-btn"
          (click)="onEditNode(node, $event)">
    编辑
  </button>
  <button nz-button
          nzType="link"
          nzSize="small"
          class="action-btn add-btn"
          (click)="onAddChild(node, $event)">
    添加目录
  </button>
</ng-template>
